import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { ContactApi } from "../../../Shared/Constants/api";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";

export const deleteContactApi = async (id) => {
  try {
    let response = await axiosInstance.delete(`${ContactApi}/${id}`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
  }
};
